import { render, staticRenderFns } from "./Notificator.vue?vue&type=template&id=795e2a22&"
import script from "./Notificator.vue?vue&type=script&lang=ts&"
export * from "./Notificator.vue?vue&type=script&lang=ts&"
import style0 from "./Notificator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports